export const SET_ALL_QUESTIONS = "SET_ALL_QUESTIONS";
export const SELECT_QUESTION = "SELECT_QUESTION";
export const SET_INFINITE_QUESTIONS = "SET_INFINITE_QUESTIONS";
